// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VeeValidate from 'vee-validate'
import VueAnalytics from 'vue-analytics'
import VueGtm from 'vue-gtm'
import VueCookies from 'vue-cookies'
import VueIntercom from 'vue-intercom'
import VueSocialSharing from 'vue-social-sharing'
import VueClipboard from 'vue-clipboard2'

import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'

import App from './App'
import router from './router'
import store from './store'
import i18n from './i18n'
import { initTracking } from './services/posthog'

// Initializing Posthog
initTracking()

Vue.config.productionTip = false

Vue.use(VeeValidate)
Vue.use(VueCookies)
Vue.use(VueSocialSharing)
Vue.use(VueClipboard)
Vue.use(VueIntercom, { appId: 'dnvys30i' })

const prod = process.env.NODE_ENV === 'production'
if (prod) {
  Vue.use(VueAnalytics, {
    id: 'UA-135624033-1',
    router
  })
  Sentry.init({
    Vue,
    dsn: 'https://df0b4e580c664db19bf0a9e75b43ed26@o537383.ingest.sentry.io/5655502',
    integrations: [new Integrations.BrowserTracing()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
    debug: !prod,
    environment: prod ? 'production' : 'development'
  })
}

if (prod) {
  Vue.use(VueGtm, {
    debug: true, // Whether or not display console logs debugs (optional)
    vueRouter: router // Pass the router instance to automatically sync with router (optional)
  })
}

// Register a global custom directive called v-focus
Vue.directive('focus', {
  // When the bound element is inserted into the DOM...
  inserted: function (el, binding) {
    // Focus the element
    if (binding.value) {
      el.focus()
    } else if (binding.value === undefined) {
      el.focus()
    }
  }
})

Vue.mixin({
  methods: {
    isValidPhone: phoneNumber => {
      const PATTERN = /^1?-?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/
      return PATTERN.test(phoneNumber)
    }
  }
})

/* eslint-disable no-new */
// app =
new Vue({
  el: '#app',
  template: '<App/>',
  components: { App },
  router,
  i18n,
  store,
  created () {
    if (this.$route.path !== '/support-chat' && this.isMobile) {
      this.$intercom.shutdown()
    }
  },
  mounted () {
    prod && window.fbq('init', '922477498176677')
    if (this.$store.state.token && this.$store.state.user_id) {
      this.$store.dispatch('getUserInformation')
    }
  },
  computed: {
    isMobile () {
      return (window.orientation !== undefined) || (navigator.userAgent.indexOf('IEMobile') !== -1)
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js